<template>
    <div class="user_details_sec">
        <div class="w-12">
            <div class="icon_wrapper"><slot/></div>
        </div>
        <div>
            <span class=" text-gray-400 uppercase">{{ title }}</span>
            <p><b class=" font-[500]">{{ value }}</b></p>
        </div>
    </div>
</template>

<script>
export default {
   props: {
       title: {},
       value: {}
    }
}
</script>

<style lang="scss" scoped>

.user_details_sec {
    @apply flex w-full sm:w-[49%] md:w-[32.3333333%] xl:!w-[24%] mb-7 gap-4;

    div {
        @apply text-[14.5px]
    }
}
.icon_wrapper{
    @apply w-10 h-10 bg-gray-100/40 rounded-2xl justify-center items-center inline-flex;
    img{
        @apply w-5 h-5 rounded-full mt-1
    }
}
</style>